module.exports = __webpack_public_path__ + "static/img/kfpt.88e4aed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kfpt.png
// module id = hD0O
// module chunks = 0